import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Container, Card, Nav, Breadcrumb } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import AllNotifications from "./AllNotifications";
import UnreadNotifications from "./UnreadNotifications";
import { useApi } from "../../Controller/ApiController";
import { PURCHASE_VIEW } from "../../Routes/SalesAndPurchase/Purchase";
import { SALES_QUOTATION_VIEW } from "../../Routes/SalesAndPurchase/SalesQuotation";
import { TAX_INVOICE_VIEW } from "../../Routes/SalesAndPurchase/TaxInvoice";
import { PROFORMAINVOICES_VIEW } from "../../Routes/SalesAndPurchase/ProformaInvoices";
import { INWARD_DOCUMENT_VIEW } from "../../Routes/SalesAndPurchase/InwardDocument";
import { SALES_RETURN_VIEW } from "../../Routes/SalesAndPurchase/SalesReturn";
import { PRODUCT_EDIT } from "../../Routes/Inventory/Product";
import { APPROVALS_LIST } from "../../Routes/Setting/Approvals";
import { PROJECTS_VIEW } from "../../Routes/Project/Project";
import { STOCK_INVENTORY_ID_VIEW } from "../../Routes/Inventory/StockInventory";

interface Notification {
  id: number;
  compareStatus: boolean;
  data: {
    message: string;
    email: string;
    mobile_number: number;
    visitorId: number;
  };
  created_at: string;
  read_at: Date | null;
}

function Notifications() {
  const { apiGet, apiPost } = useApi();
  const [showNotification, setShowNotification] = useState<Notification[]>([]);
  // const [unreadNotifications, setUnreadNotifications] = useState<
  //   Notification[]
  // >([]);
  const [unreadCount, setUnreadNotifications] = useState(0);
  const [showUnreadNotifications, setShowUnreadNotifications] = useState(false);
  const location = useLocation();
  const activeKeyParam = new URLSearchParams(location.search).get("activeKey");
  const activeKey = activeKeyParam || "all";
  const navigate = useNavigate();
  const handleNavigate = (key: any) => {
    const newUrl = `${location.pathname}?activeKey=${key}`;
    navigate(newUrl);
  };
  const unreadRef = useRef<{
    fetchUnreadNotifications: () => void;
  }>(null);

  const handleRefresh = () => {
    unreadRef.current?.fetchUnreadNotifications();
  };

  const notificationRef = useRef<any>(null);

  const handlerefresh = () => {
    if (notificationRef.current) {
      notificationRef.current.refreshNotifications(); // call fetch from child
    }
  };

  const getNotificationData = async (page = 1) => {
    try {
      const response = await apiPost(`notifications/search?page=${page}`, {
        sort: [{ field: "created_at", direction: "desc" }],
      });

      const notifications = response.data.map((notification: Notification) => {
        return {
          ...notification,
        };
      });

      setShowNotification((prevNotifications) => [
        ...prevNotifications,
        ...notifications,
      ]);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  useEffect(() => {
    getNotificationData();
    setShowUnreadNotifications(!showUnreadNotifications);
    if (!showUnreadNotifications) {
      unreadNotification();
    }
    // eslint-disable-next-line
  }, []);

  const markAllNotificationsAsRead = async () => {
    const unread = showNotification.filter(
      (notification) => notification.read_at === null,
    );
    try {
      if (unread.length > 0) {
        await apiGet(`notification/read`);
      }
      handleRefresh();
      handlerefresh();
      unreadNotification();
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  };

  const unreadNotification = async () => {
    try {
      const response = await apiPost(`notifications/search`, {
        filters: [
          {
            field: "read_at",
            operator: "=",
            value: null,
          },
        ],
      });
      setUnreadNotifications(response.meta.total || 0);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const handleMarkAsRead = (notificationId: number) => {
    setShowNotification((prevNotifications) =>
      prevNotifications.map((notification) =>
        notification.id === notificationId
          ? { ...notification, read_at: new Date() }
          : notification,
      ),
    );
    // updateUnreadNotifications();
  };

  const handleDeleteNotification = (notificationId: number) => {
    setShowNotification((prevNotifications) =>
      prevNotifications.filter(
        (notification) => notification.id !== notificationId,
      ),
    );
  };
  const viewNotificationData = async (data: any) => {
    const {
      type = "",
      subject = "",
      entity_id,
      entity_type = "",
      document_number,
    } = data;
    const lowerType = type.toLowerCase();
    const lowerSubject = subject.toLowerCase();

    if (lowerType.includes("purchase_order")) {
      navigate(PURCHASE_VIEW.replace(":id", entity_id.toString()));
    } else if (lowerType.includes("sales_quotation")) {
      navigate(SALES_QUOTATION_VIEW.replace(":id", entity_id.toString()));
    } else if (lowerType.includes("sales_return")) {
      navigate(SALES_RETURN_VIEW.replace(":id", entity_id.toString()));
    } else if (lowerType.includes("proforma_invoice")) {
      navigate(PROFORMAINVOICES_VIEW.replace(":id", entity_id.toString())); // moved above "invoice"
    } else if (lowerType.includes("invoice")) {
      navigate(TAX_INVOICE_VIEW.replace(":id", entity_id.toString()));
    } else if (lowerType.includes("project")) {
      navigate(PROJECTS_VIEW.replace(":id", entity_id.toString()));
    } else if (lowerType.includes("manual_adjustment")) {
      navigate(
        STOCK_INVENTORY_ID_VIEW.replace(":document_number", document_number),
      );
    } else if (lowerType.includes("inward_document")) {
      navigate(INWARD_DOCUMENT_VIEW.replace(":id", entity_id.toString()));
    } else if (lowerType.includes("payment")) {
      navigate(TAX_INVOICE_VIEW.replace(":id", entity_id.toString()));
    } else if (
      lowerSubject.includes("product update") ||
      entity_type === "App\\Models\\Product"
    ) {
      navigate(PRODUCT_EDIT.replace(":id", entity_id.toString()));
    } else if (
      lowerSubject.includes("approval update") ||
      entity_type === "App\\Models\\Approvals"
    ) {
      navigate(APPROVALS_LIST.replace(":id", entity_id.toString()));
    } else {
      console.warn("Unhandled notification type:", data);
    }
  };

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          Notifications
        </Breadcrumb.Item>
      </Breadcrumb>
      <Container className="container mt-5">
        <Card className="shadow-sm">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Notifications</h5>
              <button
                className="text-secondary fw-bold px-2 py-1 rounded hover-bg-light border-0 "
                style={{ cursor: "pointer", transition: "0.2s ease" }}
                onClick={markAllNotificationsAsRead}
              >
                Mark all as read
              </button>
            </div>
            <Nav variant="tabs" activeKey={activeKey}>
              <Nav.Item>
                <Nav.Link
                  onClick={() => handleNavigate("all")}
                  eventKey="all"
                  className={`nav-link text-active-primary${
                    activeKey === "all" ? "active" : ""
                  }`}
                >
                  All
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  onClick={() => handleNavigate("unread")}
                  eventKey="unread"
                  className={`nav-link text-active-primary${
                    activeKey === "unread" ? "active" : ""
                  }`}
                >
                  Unread ({unreadCount})
                </Nav.Link>
              </Nav.Item>
            </Nav>
            {activeKey === "all" && (
              <AllNotifications
                ref={notificationRef}
                onMarkAsRead={handleMarkAsRead}
                onDelete={handleDeleteNotification}
                viewNotificationData={viewNotificationData}
                unreadNotification={unreadNotification}
              />
            )}
            {activeKey === "unread" && (
              <UnreadNotifications
                ref={unreadRef}
                onMarkAsRead={handleMarkAsRead}
                onDelete={handleDeleteNotification}
                viewNotificationData={viewNotificationData}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default Notifications;
